<template>
  <AuthWrongBase>
    El email y/o la contraseña introducidos no son válidos
  </AuthWrongBase>
</template>

<script>
import AuthWrongBase from '@/components/AuthWrongBase'

export default {
  components: { AuthWrongBase },
}
</script>
